import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { faMinusCircle, faPlusCircle } from '../../../../icons';

@Component({
    selector: 'app-qty-button',
    templateUrl: './qty-button.component.html',
    styleUrls: ['./qty-button.component.scss'],
    standalone: false
})
export class QtyButtonComponent implements OnInit {
	@Input() quantity: number;
	@Input() min: number;
	@Input() max: number;

	@Output() change: EventEmitter<{value: number, updated: boolean}> = new EventEmitter();

  faMinusCircle = faMinusCircle;
  faPlusCircle = faPlusCircle;

  constructor() { }

  ngOnInit(): void {

  }

  minus() {
  	let res = {
  		value: this.quantity,
  		updated: false
  	};
  	if(this.quantity - 1 < (this.min || -999999999)) {
  		this.change.emit(res);
  	} else {
  		this.change.emit({
  			value: this.quantity - 1,
  			updated: true
  		});
  	}
  }
  plus() {
  	let res = {
  		value: this.quantity,
  		updated: false
  	};
  	if(this.quantity + 1 > (this.max || 999999999)) {
  		this.change.emit(res);
  	} else {
  		this.change.emit({
  			value: this.quantity + 1,
  			updated: true
  		});
  	}
  }

}
